import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import nav from "@/nav";
import {getRoutes} from "@/nav-lib";

Vue.use(VueRouter)

const routes: Array<RouteConfig> = getRoutes(nav);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
